<app-main-page
    *ngIf="!isLoading"
    class="page"
    [brand]="brand"
    [model]="model"
    [financialData]="financialData"
    [isPortraitDevice]="isPortraitDevice"
    [isLoading]="isLoading"
></app-main-page>
